import {
  AccountLogIn,
  AccountLogOut,
  AdminGetRoutes
} from '@/api/account'
import {
  GetBrandSiteInfo
} from '@/api/brand'
import {
  getToken,
  getRefreshToken,
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
  setUserId,
  removeUserId,
  setUserRealName,
  removeUserRealName,
  setBrandId,
  setBrnadTitle,
  setSiteId,
  setSiteTitle,
  setSiteLogoImgSm,
  setSiteInvoiceCode,
  setSiteInvoiceHashKey,
  setSiteInvoiceHashIv,
  setSitePaymentFlowCode,
  setSitePaymentFlowHashKey,
  setSitePaymentFlowHashIv,
  setSiteVenueReservationDaysLimit,
} from '@/utils/auth'
import { ElNotification } from 'element-plus'

const getDefaultState = () => {
  return {
    token: getToken(),
    refreshToken: getRefreshToken(),
    name: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.refreshToken = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PATH_LIST: (state, pathList) => {
    state.pathList = pathList
  }
}

const actions = {
  // brand/get-brand-site-info
  getBrandSiteInfo({
    commit
  }, url) {
    return new Promise((resolve, reject) => {
      GetBrandSiteInfo(url)
        .then((result) => {
          if (result.returnCode === '200' && result.data !== null) {
            const {
              data
            } = result
            setBrandId(data.brandId)
            setBrnadTitle(data.brandTitle)
            setSiteId(data.siteId)
            setSiteTitle(data.siteTitle)
            setSiteInvoiceCode(data.ecPayInvoiceCode)
            setSiteInvoiceHashKey(data.ecPayInvoiceHashKey)
            setSiteInvoiceHashIv(data.ecPayInvoiceHashIv)
            setSitePaymentFlowCode(data.ecPayPaymentFlowCode)
            setSitePaymentFlowHashKey(data.ecPayPaymentFlowHashKey)
            setSitePaymentFlowHashIv(data.ecPayPaymentFlowHashIv)
            setSiteVenueReservationDaysLimit(data.venueReservationDaysLimit)
            if (data.imgSiteLogo?.sm.key) {
              setSiteLogoImgSm(data.imgSiteLogo.sm.value)
            }
            resolve()
          } else {
            ElNotification({
              title: result.returnMsg,
              type: 'error',
              duration: 2000
            })
            reject(new Error(response.returnMsg))
          }
        }).catch(error => {
          reject(new Error(error))
        })
    })
  },
  // user/login
  login({
    commit
  }, userInfo) {
    const {
      brandId,
      username,
      encPwd
    } = userInfo
    return new Promise((resolve, reject) => {
      AccountLogIn({
        brandId,
        username,
        encPwd
      })
        .then((response) => {
          if (response.returnCode === '200' && response.data !== null) {
            const { data } = response
            const { profile } = data
            setToken(data.token)
            setRefreshToken(data.refreshToken)
            setUserId(profile.id)
            setUserRealName(profile.name)
            resolve(profile)
          } else {
            ElNotification({
              title: response.returnMsg,
              type: 'error',
              duration: 2000
            })
            reject(new Error(response.returnMsg))
          }
        }).catch(error => {
          reject(new Error(error))
        })
    })
  },
  // get user info
  getInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      AdminGetRoutes().then(response => {
        const {
          data
        } = response
        if (data !== null) {
          const {
            group_names,
            paths
          } = data
          commit('SET_ROLES', group_names)
          commit('SET_PATH_LIST', paths)
          resolve(data)
        } else {
          ElNotification({
            title: response.returnMsg,
            type: 'error',
            duration: 2000
          })
          reject(new Error(response.returnMsg))
        }
      }).catch(error => {
        reject(new Error(error))
      })
    })
  },

  // user logout
  logout({
    commit
  }) {
    return new Promise((resolve, reject) => {
      AccountLogOut().then(() => {
        removeToken() // must remove  token  first
        removeRefreshToken()
        removeUserId()
        removeUserRealName()
        commit('RESET_STATE')
        resolve()
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      removeRefreshToken()
      commit('SET_ROLES', [])
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}